import _Abstract from "system/abstract"

//No longer using the youtube API, too much can go wrong to override the theme
//and even using it we cant override the play / pause buttons *sad face*

//A global loader to get the youtube JavascriptAPI loaded
//This only needs to run once, so we run it outside of an instantiated class
// var onYoutubeloadedCallbacks = [];
// var bYoutubeAPILoaded = false;
// $.getScript("//www.youtube.com/player_api", function()
// {
//     var yt_int = setInterval(function()
//     {
//         if(typeof YT === "object")
//         {
//             clearInterval(yt_int);
//             for(var i =0 ; i < onYoutubeloadedCallbacks.length; ++i)
//             {
//             	onYoutubeloadedCallbacks[i]();
//             }
//             onYoutubeloadedCallbacks = null;
//         }
//     },500);
// });

export default class Module_VideoTile extends _Abstract {

	constructor(el, options)
	{
		super(el, $.extend(true, {}, options), 'module')
		console.log(options);

		this.bIsIOSDevice = navigator.userAgent.match(/(iPod|iPhone|iPad)/);
		this.bIsYoutubeVideo = this.$el.find(".youtube-player").length;
		this.youtubeID = "";
		// if(this.bIsYoutubeVideo)
		// {
		// 	return;//dont do anything just yet
		// }
		if(this.bIsYoutubeVideo)
		{
			return;
		}
		this.initModule();

		this.HIDE_VIDEO_CONTROLS_TIME_MILLISECONDS = 2000;
		this.VIDEO_DURATION_UPDATE_TIME = 1000/30; //How often the scrub bar updates when the video is playing
	}

	/***** Initialising methods *******************/

	initModule()
	{
		this.initClassVariables();
		this.initListeners();
	}


	initClassVariables()
	{
		this.$video = this.$el.find('video');
		this.video = null;
		// this.$youtubeVideoIframe = null;
		this.$youtubeVideoIframe = this.$el.find('.youtube-player');
		this.bIsYoutubeVideo = this.$youtubeVideoIframe !== 0;
		this.youtubePlayerInstance = null;
		this.youtubePlayerState = null;
		this.onDocumentBoundMouseMoveHandler = this.onDocumentMouseMoveHandler.bind(this);

		this.initialiseVideoControls();

		if(this.$video.length)
		{
			this.initialiseHTML5Video();
		}
		else if(this.bIsYoutubeVideo)
		{
			this.youtubeID = this.$el.find("[name='youtube-id']").val();
			this.initialiseYoutubeImage();
			this.initialiseYoutubeVideo();
		}
		else
		{
			return;
		}


	}

	initialiseVideoControls()
	{
		this.isScrubbing = false;
		this.hideControlsTimer = null;
		this.scrubBarTimer = null;
		this.youtubeCountdownTimer = null;
		this.$videoContainer = this.$el.find('.video-ctn');
		this.$videoControlsContainer = this.$el.find('.video-controls');
		this.$videoControlsPlayButton = this.$el.find('.video-controls-play-btn');
		this.$videoControlsPauseButton = this.$el.find('.video-controls-pause-btn');
		this.$videoControlsScrubBarContainer = this.$el.find('.video-controls-scrub-bar-container');
		this.$videoControlsScrubBarDuration = this.$el.find('.video-controls-scrub-bar-duration');
		this.$videoControlsTime = this.$el.find('.video-controls-time');
		this.$videoControlsFullScreen = this.$el.find('.video-controls-full-screen');
		this.$videoControlsExitFullScreen = this.$el.find('.video-controls-exit-full-screen');
	}

	initialiseHTML5Video()
	{
		this.video = this.$video[0];

		if (this.bIsIOSDevice) {
			this.video.load();
		}
	}



	/***** Youtube Callbacks and methods *******************/

	initialiseYoutubeImage()
	{
		// this.$el.find(".video-ctn").css("background-image","url('http://img.youtube.com/vi/"+this.youtubeID+"/maxresdefault.jpg')");
	}

	initialiseYoutubeVideo()
	{

		var youtubeEmbedURL = "https://www.youtube.com/embed/"+this.youtubeID+"?version=3&amp;enablejsapi=1&amp;autoplay=0&amp;autohide=1&amp;showinfo=0&amp;modestbranding=1&amp;rel=0&amp;controls=0";

		if(this.bIsIOSDevice)
		{
			youtubeEmbedURL = "https://www.youtube.com/embed/"+this.youtubeID;
			// this.$el.find(".youtube-player-overlay").remove();
			this.$el.find(".video-controls").remove();
			this.$el.find(".video-controls-time").remove();
			this.$el.find(".video-controls-scrub-bar-container").remove();
		}

		this.$youtubeVideoIframe.attr("src",youtubeEmbedURL);


		if(bYoutubeAPILoaded)
		{
			this.onYoutubeAPILoaded();
		}
		else
		{
			onYoutubeloadedCallbacks.push(() => this.onYoutubeAPILoaded());
		}
	}

	onYoutubeAPILoaded()
	{
		console.log("onYoutubeAPILoaded");
			// this.video.addEventListener("timeupdate", (e)=> this.onVideoTimeUpdate(e));


		var player = new YT.Player(this.$youtubeVideoIframe[0],{
			events: {
				'onReady' : (e) => this.onYoutubePlayerInstanceReady(e),
				'onStateChange' : (e) => this.onYoutubePlayerInstanceStateChange(e),

			}
		});
	}

	onYoutubePlayerInstanceReady(event)
	{
		this.youtubePlayerInstance = event.target;

	}

	onYoutubePlayerInstanceStateChange(event)
	{
		this.youtubePlayerState = event.data;
		switch(event.data)
		{
			case YT.PlayerState.ENDED:
			case YT.PlayerState.PAUSED:
			{
				this.onVideoPaused();
				this.updateCountDownTimer();
				window.clearInterval(this.youtubeCountdownTimer);
				this.youtubeCountdownTimer = null;

				break;
			}

			case YT.PlayerState.BUFFERING:
			{
				break;
			}

			case YT.PlayerState.PLAYING:
			case YT.PlayerState.CUED:
			{
				this.$videoContainer.css("background-image","none");
				this.$youtubeVideoIframe.removeClass("-hide");

				this.onVideoPlaying();
				this.youtubeCountdownTimer = window.setInterval(() => this.updateCountDownTimer(), 1000);
				break;
			}
		}
	}


	/***** Initialising Event Listeners *******************/

	initListeners()
	{

		document.addEventListener("fullscreenchange", (e) => this.onFullScreenChange(e));
		document.addEventListener("webkitfullscreenchange", (e) => this.onFullScreenChange(e));
		document.addEventListener("mozfullscreenchange", (e) => this.onFullScreenChange(e));
		document.addEventListener("MSFullscreenChange", (e) => this.onFullScreenChange(e));
		this.$videoControlsFullScreen.click((e) => this.onFullScreenClicked(e));
		this.$videoControlsExitFullScreen.click((e) => this.onExitFullScreenClicked(e));
		this.$videoContainer.click((e) => this.onVideoContainerClicked(e));
		this.$videoContainer.mousemove((e)=> this.onMouseMoveOnVideoContainer(e));

		
		if(this.video)
		{
			$(document).mouseleave(() => { 
				this.isScrubbing = false;
				$(document).off('mousemove', this.onDocumentBoundMouseMoveHandler);
				this.setCurrentTimeBasedOffScrubBarPosition();
			});

			$(document).mouseup(() => { 
				this.isScrubbing = false;
				$(document).off('mousemove', this.onDocumentBoundMouseMoveHandler);
				this.setCurrentTimeBasedOffScrubBarPosition();
			});
			this.$videoContainer.on('mousedown', (e) => this.onHTML5VideoContainerMouseDown(e));
			this.video.addEventListener("play", (e)=> this.onVideoPlaying(e));
			this.video.addEventListener("pause", (e)=> this.onVideoPaused(e));
			this.video.addEventListener("timeupdate", (e)=> this.onVideoTimeUpdate(e));
		}
		else if(this.bIsYoutubeVideo)
		{
			// this.$el.find(".youtube-player-overlay").click((e) => this.preventDefaultAndToggleVideo(e));
			// this.$el.find(".youtube-player-overlay").on("touchstart",(e) => this.preventDefaultAndToggleVideo(e));
			// this.$el.find(".youtube-player-overlay").mousedown((e) => this.preventDefault(e));
		}
		
	}

	preventDefaultAndToggleVideo(e)
	{
		this.preventDefault(e);
		this.toggleVideoPlayState();


	}

	preventDefault(e)
	{
		if (!e.preventDefault)
        {//IE quirks
            e.returnValue = false;
            e.cancelBubble = true;
        }
        e.preventDefault();
        e.stopPropagation();
	}


	/***** Responding to Full Screen Change Events *******************/

	onFullScreenChange(e)
	{
		// console.log(e);
		if(this.isCurrentlyFullscreen())
		{
			this.showCancelFullScreenButtonHideGoFullScreenButton();
		}
		else
		{
			this.showGoFullScreenButtonHideCancelFullScreenButton();
		}
	}

	isCurrentlyFullscreen()
	{
	    var bIsFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || (typeof document.msFullscreenElement !== 'undefined' && document.msFullscreenElement != null);
	    return bIsFullScreen;
	}


	/***** Responding to Native HTML Video Events *******************/


	onVideoPlaying(e)
	{
		console.log('onVideoPlaying');
		this.showPauseButtonHidePlayButton();
		this.setHideControlsTimer();
		this.setScrubBarTimer();
	}

	onVideoPaused(e)
	{
		console.log('onVideoPaused');
		this.showPlayButtonHidePauseButton();
		this.showVideoControls();
		this.clearScrubBarTimer();
	}

	//Note, we only use this video for the clock timer
	//As using this for the scrub bar, the update rate is far too slow
	onVideoTimeUpdate(e)
	{
		this.updateCountDownTimer();
	}



	/***** Responding to Mouse Movement Events *******************/

	onMouseMoveOnVideo(e)
	{
		this.showVideoControls();
	}

	// onMouseMoveOnVideoControlsContainer()
	// {
	// 	if(!this.video.playing)
	// 	{
	// 		return;
	// 	}
	// 	console.log('onMouseMoveOnVideoControlsContainer');
	// 	this.showVideoControls();
	// }

	onMouseMoveOnVideoContainer(mouseEvent)
	{
		// var x = mouseEvent.pageX - this.$el.offset().left;
		var mouseY = mouseEvent.pageY - this.$el.find('.video-ctn').offset().top;
		//check if they're at a percentage from the bottom

		var heightOfContainer = this.$el.find('.video-ctn').height();

		var percentageOfPosition = (mouseY / heightOfContainer) * 100;
		if(percentageOfPosition >= 90)
		{
			this.$el.addClass('larger-footer-controls');
		}
		else
		{
			this.$el.removeClass('larger-footer-controls');
		}

		// console.log('onMouseMoveOnVideoContainer');
		this.showVideoControls();
	}

	onDocumentMouseMoveHandler(mouseEvent)
	{
		var percentageX = this.getMousePercentageOnContainerFromEvent(mouseEvent);
		this.setPercentageOfScrubBar(percentageX);
	}

	/***** Video State Changes *******************/
	setCurrentTimeBasedOffScrubBarPosition()
	{
		//This is 0-1 not 0-100
		var scrubDecimalFraction = this.$videoControlsScrubBarDuration.width() / this.$videoControlsScrubBarContainer.width();
		this.video.currentTime = this.video.duration * scrubDecimalFraction;
	}



	/***** Responding to Click Events *******************/

	onHTML5VideoContainerMouseDown(mouseEvent)
	{
		var $target = $(mouseEvent.target);
		if(!this.isHTML5VideoAndClickedWithinScrubber(mouseEvent))
		{
			return;
		}

		if(this.isScrubbing)
		{
			return;
		}

		this.isScrubbing = true;
		$(document).on('mousemove', this.onDocumentBoundMouseMoveHandler);
	}


	onVideoContainerClicked(mouseEvent)
	{
		if(this.isScrubbing)
		{
			return;
		}
		console.log("onVideoContainerClicked");	
		if(this.$el.hasClass("-fullscreen-on-play") && this.isVideoPaused())
		{
			this.onFullScreenClicked();
		}

		if(this.isHTML5VideoAndClickedWithinScrubber(mouseEvent))
		{
			var percentageX = this.getMousePercentageOnContainerFromEvent(mouseEvent);
			this.video.currentTime = this.video.duration * (percentageX /100);
			this.updateCountDownTimer();
			this.onScrubBarTick();
		}
		else
		{
			this.toggleVideoPlayState();
		}
	
	}
	
	getMousePercentageOnContainerFromEvent(mouseEvent)
	{
		var widthOfContainer = this.$el.find('.video-ctn').width();
		var mouseX = mouseEvent.pageX - this.$el.find('.video-ctn').offset().left;
		var percentageX = mouseX / widthOfContainer;
		if(percentageX < 0)
		{
			percentageX = 0;
		}
		else if(percentageX > 1)
		{
			percentageX = 1;
		}

		percentageX *= 100;

		return percentageX;
	}


	isHTML5VideoAndClickedWithinScrubber(mouseEvent)
	{
		if(!this.video)
		{
			return;
		}

		var $clickedTarget = $(mouseEvent.target);
		var mouseY = mouseEvent.pageY - this.$el.find('.video-ctn').offset().top;
		var heightOfContainer = this.$el.find('.video-ctn').height();
		var heightOfScrubber = this.$el.find('.video-controls-scrub-bar-container').height();
		var clickedWithinScrubBar = mouseY >= (heightOfContainer - heightOfScrubber);
		return clickedWithinScrubBar;
	}

	toggleVideoPlayState()
	{
		if(this.video)
		{
			if(this.isVideoPaused())
			{
				this.video.play();
			}
			else
			{
				this.video.pause();
			}
		}
		else if(this.youtubePlayerInstance)
		{
			if(this.isVideoPaused())
			{
				this.youtubePlayerInstance.playVideo();
			}
			else
			{
				this.youtubePlayerInstance.pauseVideo();
			}
		}
	}

	
	onFullScreenClicked(e)
	{
		//Stop propagation so the click event on the video container doesnt get called
		if(typeof e !== "undefined")
		{
			e.preventDefault();
			e.stopPropagation();
		}

		if(!this.$video.length)
		{
			return;
		}

		var videoContainer = this.$el.find(".video-ctn")[0];
		if(videoContainer.requestFullscreen){
		  videoContainer.requestFullscreen();
		} else if(videoContainer.mozRequestFullScreen) {
		  videoContainer.mozRequestFullScreen();
		} else if(videoContainer.webkitRequestFullscreen) {
		  videoContainer.webkitRequestFullscreen();
		} else if(videoContainer.msRequestFullscreen) {
		  videoContainer.msRequestFullscreen();
		}
		else if(typeof this.$video[0].webkitEnterFullscreen !== "undefined")
		{
			this.$video[0].webkitEnterFullscreen();
		}
	}


	onExitFullScreenClicked(e)
	{
		e.preventDefault();
		e.stopPropagation();
		// exit full-screen
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		}	
	}

	/***** Changing button states *******************/

	showPlayButtonHidePauseButton()
	{
		this.$videoControlsPlayButton.removeClass("-hide");
		this.$videoControlsPauseButton.addClass("-hide");
	}

	showPauseButtonHidePlayButton()
	{
		this.$videoControlsPauseButton.removeClass("-hide");
		this.$videoControlsPlayButton.addClass("-hide");
	}

	showGoFullScreenButtonHideCancelFullScreenButton()
	{
		this.$videoControlsFullScreen.removeClass("-hide");
		this.$videoControlsExitFullScreen.addClass("-hide");

	}

	showCancelFullScreenButtonHideGoFullScreenButton()
	{
		this.$videoControlsExitFullScreen.removeClass("-hide");
		this.$videoControlsFullScreen.addClass("-hide");
	}


	/***** Hiding and showing the video controls container timer *******************/

	updateCountDownTimer()
	{

		var videoDuration = this.video ? this.video.duration : this.youtubePlayerInstance.getDuration();
		var videoCurrentTime = this.video ? this.video.currentTime : this.youtubePlayerInstance.getCurrentTime();

		var totalSecondsRemaining = videoDuration - videoCurrentTime;

		var minutesRemaining = Math.floor(totalSecondsRemaining /60);
		var secondsRemaining = Math.floor(totalSecondsRemaining %60);

		if(minutesRemaining < 10)
		{
			minutesRemaining = "0" + minutesRemaining;
		}

		if(secondsRemaining < 10)
		{
			secondsRemaining = "0" + secondsRemaining;
		}

		var timeText = minutesRemaining + ":" + secondsRemaining;
		this.$videoControlsTime.text(timeText);

	}



	/***** Hiding and showing the video controls container timer *******************/


	isVideoPaused()
	{
		if(this.video)
		{
			return this.video.paused;
		}
		else if(this.youtubePlayerInstance)
		{
			return this.youtubePlayerState === null || this.youtubePlayerState === YT.PlayerState.ENDED || this.youtubePlayerState === YT.PlayerState.PAUSED;
		}
		return false;
	}

	clearHideControlsTimer()
	{
		if(this.hideControlsTimer === null)
		{
			return;
		}

		window.clearTimeout(this.hideControlsTimer);
		this.hideControlsTimer = null;
	}

	setHideControlsTimer()
	{
		this.clearHideControlsTimer();
		this.hideControlsTimer = window.setTimeout(() => this.onHideControlsTimerExpired(),this.HIDE_VIDEO_CONTROLS_TIME_MILLISECONDS);
	}

	onHideControlsTimerExpired()
	{
		this.clearHideControlsTimer();
		this.hideVideoControls();
	}

	hideVideoControls()
	{
		if(this.isVideoPaused())
		{
			return;
		}

		this.$videoControlsContainer.stop(true).fadeOut();
	}

	showVideoControls()
	{
		this.setHideControlsTimer();
		this.$videoControlsContainer.stop(true).fadeIn();
	}

	/***** Scrub Bar timer *******************/

	clearScrubBarTimer()
	{
		if(this.scrubBarTimer === null)
		{
			return;
		}

		window.clearInterval(this.scrubBarTimer);
		this.scrubBarTimer = null;
	}

	setScrubBarTimer()
	{
		this.clearScrubBarTimer();
		this.scrubBarTimer = window.setInterval(() => this.onScrubBarTick(),this.VIDEO_DURATION_UPDATE_TIME);
	}

	onScrubBarTick()
	{
		if(this.isScrubbing)
		{
			//If it's scrubbing then dont update the scrub percentage as it may interrupt
			return;
		}
		var videoCurrentTime  =  this.video ? this.video.currentTime : this.youtubePlayerInstance.getCurrentTime();
		var videoDuration = this.video ? this.video.duration : this.youtubePlayerInstance.getDuration();
		var percentageDuration = (videoCurrentTime / videoDuration) * 100;
		this.setPercentageOfScrubBar(percentageDuration);
	}


	/**
	 * 
	 * @param {number} percentageDuration The percentage width of the timer scrubber
	 */
	setPercentageOfScrubBar(percentageDuration)
	{
		this.$videoControlsScrubBarDuration.css("width",percentageDuration + "%");
	}


}



/** WEBPACK FOOTER **
 ** ./modules/video-tile.js
 **/